// Configuration centralisée de tous les métiers
// Un seul fichier pour gérer tous les contenus et variants

export const metiers = {
      masseurs: {
        id: 'masseurs',
        nom: 'Masseurs',
        nomPluriel: 'masseurs',
        icon: 'Spa',
        couleurMetier: '#FFB300',
        b2b: {
          titre: "Développez votre activité de massage avec LYS B2B",
          roi: { timeToValue: "36h", clientsGain: "+54 clients fidélisés", caSupplement: "+18% CA", tempsGagne: "5h/sem gagnées" },
          pricing: [
            { nom: "Masseur Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Planning RDV", "Facturation rapide", "Support email"], cta: "Démarrer" },
            { nom: "Cabinet Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Gestion multi-cabinets", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
            { nom: "Entreprise Massage+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations ERP", "Formation équipe"], cta: "Nous contacter" }
          ],
          arguments: ["Planning intelligent", "Facturation simplifiée", "Gestion multi-cabinets", "Support métier dédié"]
        },
        hero: {
          titre: 'La solution LYS pour masseurs',
          soustitre: 'Gérez planning, clients et facturation avec l’expertise massage',
          badges: [
            '💆 +70% productivité',
            '📅 Planning intelligent',
            '🏢 800+ masseurs'
          ]
        },
        benefices: [
          { icon: 'Spa', titre: 'Planning RDV automatiques', description: 'Optimisation des créneaux, gestion des absences, urgences.', temoignage: 'Mon planning est toujours rempli' },
          { icon: 'ReceiptLong', titre: 'Facturation rapide', description: 'Génération automatique des factures, relances clients, suivi paiements.', temoignage: 'Je gagne 1h par semaine sur la facturation' },
          { icon: 'Group', titre: 'Gestion multi-cabinets', description: 'Ajoutez et gérez plusieurs cabinets ou clients en un clic.', temoignage: 'Je pilote 2 cabinets sans stress' },
          { icon: 'SupportAgent', titre: 'Support métier dédié', description: 'Assistance métier, conseils optimisation, hotline dédiée.', temoignage: 'Support réactif et efficace' }
        ],
        temoignages: [
          { nom: 'Julie Zen', entreprise: 'Zen Massage', ville: 'Nice', avatar: 'JZ', metier: 'Masseuse', note: 5, chiffre: '+70% productivité', texte: 'LYS m’a permis d’optimiser mes RDV et de gagner du temps sur la facturation.', resultats: { avant: '5 clients/semaine', apres: '12 clients/semaine', gain: 'x2' } },
          { nom: 'Eric Relax', entreprise: 'Relax & Co', ville: 'Bordeaux', avatar: 'ER', metier: 'Masseur chef', note: 5, chiffre: '2 cabinets gérés', texte: 'Je gère 2 cabinets sans stress, le planning intelligent est top !', resultats: { avant: '1 cabinet', apres: '2 cabinets', gain: 'x2' } }
        ],
        fonctionnalites: [
          'Planning RDV automatiques',
          'Facturation rapide',
          'Gestion multi-cabinets',
          'Support métier dédié',
          'Relances clients',
          'Suivi paiements',
          'Base prix massage',
          'Rapports d’activité',
          'Gestion absences',
          'Optimisation créneaux'
        ],
        stats: {
          utilisateurs: '800+',
          satisfaction: '96%',
          gainTemps: '+70%',
          conversions: '+100%'
        },
      seo: {
        title: 'LYS Masseurs - Logiciel Planning & Facturation Masseurs',
        description: 'Logiciel pour masseurs : planning intelligent, facturation rapide, gestion multi-cabinets. 800+ masseurs nous font confiance.',
        keywords: 'logiciel masseur, planning massage, facturation massage, gestion multi-cabinets'
      },
      b2bEnabled: true
    },      centresDeControleTechnique: {
        id: 'centres-de-controle-technique',
        nom: 'Contrôle Technique',
        nomPluriel: 'centres de contrôle technique',
        icon: 'CarRepair',
        couleurMetier: '#1976D2',
        b2b: {
          titre: "Gérez votre centre de contrôle technique avec LYS B2B",
          roi: { timeToValue: "48h", clientsGain: "+32 clients pros", caSupplement: "+12% CA", tempsGagne: "3h/sem gagnées" },
          pricing: [
            { nom: "Centre Solo", prix: "59€", periode: "/mois", features: ["1 utilisateur", "Planning RDV", "Facturation rapide", "Support email"], cta: "Démarrer" },
            { nom: "Centre Pro", prix: "109€", periode: "/mois", features: ["5 utilisateurs", "Gestion multi-centres", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
            { nom: "Entreprise CT+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations ERP", "Formation équipe"], cta: "Nous contacter" }
          ],
          arguments: ["Planning intelligent", "Facturation simplifiée", "Gestion multi-centres", "Support métier dédié"]
        },
        hero: {
          titre: 'LYS Contrôle Technique',
          soustitre: 'Gérez planning, clients et facturation avec l’expertise contrôle technique',
          badges: [
            '🚗 +60% productivité',
            '📅 Planning intelligent',
            '🏢 400+ centres de contrôle technique'
          ]
        },
        benefices: [
          { icon: 'CarRepair', titre: 'Planning RDV automatiques', description: 'Optimisation des créneaux, gestion des absences, urgences.', temoignage: 'Mon planning est toujours optimisé' },
          { icon: 'ReceiptLong', titre: 'Facturation rapide', description: 'Génération automatique des factures, relances clients, suivi paiements.', temoignage: 'Je gagne 1h par semaine sur la facturation' },
          { icon: 'Group', titre: 'Gestion multi-centres', description: 'Ajoutez et gérez plusieurs centres ou clients en un clic.', temoignage: 'Je pilote 2 centres sans stress' },
          { icon: 'SupportAgent', titre: 'Support métier dédié', description: 'Assistance métier, conseils optimisation, hotline dédiée.', temoignage: 'Support réactif et efficace' }
        ],
        temoignages: [
          { nom: 'Paul Contrôle', entreprise: 'CT Express', ville: 'Lille', avatar: 'PC', metier: 'Contrôleur technique', note: 5, chiffre: '+60% productivité', texte: 'LYS m’a permis d’optimiser mes RDV et de gagner du temps sur la facturation.', resultats: { avant: '10 clients/semaine', apres: '18 clients/semaine', gain: 'x2' } },
          { nom: 'Nadia Sécurité', entreprise: 'Sécurité Auto', ville: 'Strasbourg', avatar: 'NS', metier: 'Responsable centre', note: 5, chiffre: '2 centres gérés', texte: 'Je gère 2 centres sans stress, le planning intelligent est top !', resultats: { avant: '1 centre', apres: '2 centres', gain: 'x2' } }
        ],
        fonctionnalites: [
          'Planning RDV automatiques',
          'Facturation rapide',
          'Gestion multi-centres',
          'Support métier dédié',
          'Relances clients',
          'Suivi paiements',
          'Base prix contrôle technique',
          'Rapports d’activité',
          'Gestion absences',
          'Optimisation créneaux'
        ],
        stats: {
          utilisateurs: '400+',
          satisfaction: '95%',
          gainTemps: '+60%',
          conversions: '+80%'
        },
        seo: {
          title: 'LYS Contrôle Technique - Logiciel Planning & Facturation Centres CT',
          description: 'Logiciel pour centres de contrôle technique : planning intelligent, facturation rapide, gestion multi-centres. 400+ centres nous font confiance.',
          keywords: 'logiciel contrôle technique, planning CT, facturation CT, gestion multi-centres'
        },
        b2bEnabled: true
      },
    agentsDeMenage: {
      id: 'agents-de-menage',
      nom: 'Ménage',
      nomPluriel: 'agents de ménage',
      icon: 'CleaningServices',
      couleurMetier: '#00BFAE',
      b2b: {
        titre: "Optimisez votre activité de ménage avec LYS B2B",
        roi: { timeToValue: "24h", clientsGain: "+75 clients pros", caSupplement: "+22% CA", tempsGagne: "6h/sem gagnées" },
        pricing: [
          { nom: "Agent Solo", prix: "39€", periode: "/mois", features: ["1 utilisateur", "Planning interventions", "Facturation rapide", "Support email"], cta: "Démarrer" },
          { nom: "Équipe Pro", prix: "79€", periode: "/mois", features: ["5 utilisateurs", "Gestion multi-sites", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
          { nom: "Entreprise Ménage+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations ERP", "Formation équipe"], cta: "Nous contacter" }
        ],
        arguments: ["Planning intelligent", "Facturation simplifiée", "Gestion multi-sites", "Support métier dédié"]
      },
      hero: {
        titre: 'LYS Ménage',
        soustitre: 'Gérez planning, clients et facturation avec l’expertise ménage',
        badges: [
          '🧹 +80% productivité',
          '📅 Planning intelligent',
          '🏠 1 200+ agents de ménage'
        ]
      },
      benefices: [
        { icon: 'CleaningServices', titre: 'Planning interventions automatiques', description: 'Optimisation des tournées, gestion des absences, urgences.', temoignage: 'Mon planning est toujours optimisé' },
        { icon: 'ReceiptLong', titre: 'Facturation rapide', description: 'Génération automatique des factures, relances clients, suivi paiements.', temoignage: 'Je gagne 2h par semaine sur la facturation' },
        { icon: 'Group', titre: 'Gestion multi-sites', description: 'Ajoutez et gérez plusieurs sites ou clients en un clic.', temoignage: 'Je pilote 3 sites sans stress' },
        { icon: 'SupportAgent', titre: 'Support métier dédié', description: 'Assistance métier, conseils optimisation, hotline dédiée.', temoignage: 'Support réactif et efficace' }
      ],
      temoignages: [
        { nom: 'Sophie Nettoie', entreprise: 'Nettoyage Express', ville: 'Paris', avatar: 'SN', metier: 'Agent de ménage', note: 5, chiffre: '+80% productivité', texte: 'LYS m’a permis d’optimiser mes tournées et de gagner du temps sur la facturation.', resultats: { avant: '8 clients/semaine', apres: '15 clients/semaine', gain: 'x2' } },
        { nom: 'Karim Propre', entreprise: 'Propre & Net', ville: 'Marseille', avatar: 'KP', metier: 'Chef d’équipe ménage', note: 5, chiffre: '3 sites gérés', texte: 'Je gère 3 sites sans stress, le planning intelligent est top !', resultats: { avant: '1 site', apres: '3 sites', gain: 'x3' } }
      ],
      fonctionnalites: [
        'Planning interventions automatiques',
        'Facturation rapide',
        'Gestion multi-sites',
        'Support métier dédié',
        'Relances clients',
        'Suivi paiements',
        'Base prix ménage',
        'Rapports d’activité',
        'Gestion absences',
        'Optimisation tournées'
      ],
      stats: {
        utilisateurs: '1 200+',
        satisfaction: '97%',
        gainTemps: '+80%',
        conversions: '+120%'
      },
      seo: {
        title: 'LYS Ménage - Logiciel Planning & Facturation Agents de Ménage',
        description: 'Logiciel pour agents de ménage : planning intelligent, facturation rapide, gestion multi-sites. 1 200+ agents nous font confiance.',
        keywords: 'logiciel ménage, planning ménage, facturation ménage, gestion multi-sites'
      },
      b2bEnabled: true
    },
  electriciens: {
    id: 'electriciens',
    nom: 'Électriciens',
    nomPluriel: 'électriciens',
    icon: 'ElectricalServices',
    couleurMetier: '#FFD600',
    b2b: {
      titre: "Boostez votre activité électrique avec LYS B2B",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité électriciens",
      roi: { timeToValue: "48h", clientsGain: "+127 clients pros", caSupplement: "+35% CA", tempsGagne: "12h/sem gagnées" },
      pricing: [
        { nom: "Électricien Solo", prix: "49€", periode: "/mois", features: ["1 utilisateur", "Devis NF C 15-100", "Attestations Consuel auto", "Support email"], cta: "Démarrer" },
        { nom: "Équipe Pro", prix: "99€", periode: "/mois", features: ["5 utilisateurs", "Planning multi-chantiers", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Élec+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations ERP", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Devis conformes NF C 15-100", "Attestations Consuel automatiques", "Gestion multi-chantiers", "Planning intelligent", "Support métier dédié"]
    },
    hero: {
      titre: 'La solution LYS pour électriciens',
      soustitre: 'Gérez devis, chantiers et facturation avec l’expertise électricité',
      badges: [
        '⚡ +90% productivité',
        '📋 Devis conformes NF',
        '🔌 2 800+ électriciens'
      ]
    },
    benefices: [
      { icon: 'Assignment', titre: 'Devis électriques automatiques', description: 'Tableaux, prises, éclairage. Base de données complète normes NF C 15-100.', temoignage: 'Mes devis sont 3x plus rapides qu’avant' },
      { icon: 'Engineering', titre: 'Schémas électriques intégrés', description: 'Plans unifilaires, tableaux de répartition automatiques.', temoignage: 'Plus besoin de logiciel séparé' },
      { icon: 'FactCheck', titre: 'Conformité NF C 15-100', description: 'Attestations Consuel, certificats conformité générés automatiquement.', temoignage: 'Consuel validé du premier coup' },
      { icon: 'CalendarToday', titre: 'Planning chantiers optimisé', description: 'Gestion multi-chantiers, équipes, urgences dépannage.', temoignage: '2 chantiers de plus par semaine' }
    ],
    temoignages: [
      { nom: 'Pierre Ampère', entreprise: 'Élec Pro Services', ville: 'Lyon', avatar: 'PA', metier: 'Électricien installation', note: 5, chiffre: '+90% productivité', texte: 'LYS m’a permis de tripler la rapidité de mes devis et d’éviter les erreurs NF C 15-100.', resultats: { avant: '10 devis/semaine', apres: '30 devis/semaine', gain: 'x3' } },
      { nom: 'Marc Watt', entreprise: 'Watt Elec', ville: 'Toulouse', avatar: 'MW', metier: 'Électricien industriel', note: 5, chiffre: '4 équipes pilotées', texte: 'Je gère 4 équipes simultanément. Le planning intelligent évite les conflits, tout roule !', resultats: { avant: '2 équipes max', apres: '4 équipes', gain: 'x2' } }
    ],
    fonctionnalites: [
      'Devis électriques automatiques',
      'Schémas unifilaires',
      'Conformité NF C 15-100',
      'Attestations Consuel',
      'Planning multi-chantiers',
      'Gestion stocks matériel',
      'Facturation conforme',
      'Certificats garantie',
      'Rappels maintenance',
      'Fiches intervention',
      'Base prix électricité',
      'Tableaux de répartition'
    ],
    stats: {
      utilisateurs: '2 800+',
      satisfaction: '98%',
      gainTemps: '+90%',
      conversions: '+156%'
    },
    seo: {
      title: 'LYS Électriciens - Logiciel Devis & Gestion Chantiers Électricité',
      description: 'Logiciel pour électriciens : devis conformes NF C 15-100, attestations Consuel, planning chantiers. 2 800+ électriciens nous font confiance.',
      keywords: 'logiciel électricien, devis électricité, NF C 15-100, Consuel, planning chantiers'
    },
    hero: {
      titre: 'La solution LYS pour électriciens',
      soustitre: 'Gérez devis, chantiers et facturation avec l\'expertise électricité',
      badges: [
        '⚡ +90% productivité',
        '📋 Devis conformes NF',
        '🔌 2 800+ électriciens'
      ]
    },
    benefices: [
      {
        icon: 'Assignment',
        titre: 'Devis électriques automatiques',
        description: 'Tableaux, prises, éclairage. Base de données complète normes NF C 15-100.',
        temoignage: 'Mes devis sont 3x plus rapides qu\'avant'
      },
      {
        icon: 'Engineering',
        titre: 'Schémas électriques intégrés',
        description: 'Plans unifilaires, tableaux de répartition automatiques.',
        temoignage: 'Plus besoin de logiciel séparé'
      },
      {
        icon: 'FactCheck',
        titre: 'Conformité NF C 15-100',
        description: 'Attestations Consuel, certificats conformité générés automatiquement.',
        temoignage: 'Consuel validé du premier coup'
      },
      {
        icon: 'CalendarToday',
        titre: 'Planning chantiers optimisé',
        description: 'Gestion multi-chantiers, équipes, urgences dépannage.',
        temoignage: '2 chantiers de plus par semaine'
      }
    ],
    
    temoignages: [
      {
        nom: 'Pierre Ampère',
        entreprise: 'Élec Pro Services',
        ville: 'Lyon',
        avatar: 'PA',
        metier: 'Électricien installation',
        note: 5,
        chiffre: '+90% productivité',
        texte: 'LYS m’a permis de tripler la rapidité de mes devis et d’éviter les erreurs NF C 15-100.',
        resultats: {
          avant: '10 devis/semaine',
          apres: '30 devis/semaine',
          gain: 'x3'
        }
      },
      {
        nom: 'Marc Watt',
        entreprise: 'Watt Elec',
        ville: 'Toulouse',
        avatar: 'MW',
        metier: 'Électricien industriel',
        note: 5,
        chiffre: '4 équipes pilotées',
        texte: 'Je gère 4 équipes simultanément. Le planning intelligent évite les conflits, tout roule !',
        resultats: {
          avant: '2 équipes max',
          apres: '4 équipes',
          gain: 'x2'
        }
      }
    ],
    
    fonctionnalites: [
      'Devis électriques automatiques',
      'Schémas unifilaires',
      'Conformité NF C 15-100',
      'Attestations Consuel',
      'Planning multi-chantiers',
      'Gestion stocks matériel',
      'Facturation conforme',
      'Certificats garantie',
      'Rappels maintenance',
      'Fiches intervention',
      'Base prix électricité',
      'Tableaux de répartition'
    ],
    
    stats: {
      utilisateurs: '2 800+',
      satisfaction: '98%',
      gainTemps: '+90%',
      conversions: '+156%'
    },
    
    seo: {
      title: 'LYS Électriciens - Logiciel Devis & Gestion Chantiers Électricité',
      description: 'Logiciel pour électriciens : devis conformes NF C 15-100, attestations Consuel, planning chantiers. 2 800+ électriciens nous font confiance.',
      keywords: 'logiciel électricien, devis électricité, NF C 15-100, Consuel, planning chantiers'
    },
    b2bEnabled: true
  },

  plombiers: {
    b2b: {
      titre: "LYS B2B - La plomberie connectée et rentable",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité plombiers",
      roi: { timeToValue: "72h", clientsGain: "+98 clients fidélisés", caSupplement: "+28% CA dépannage", tempsGagne: "8h/sem économisées" },
      pricing: [
        { nom: "Plombier Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Devis DTU 60.1", "Gestion urgences 24/7", "Support email"], cta: "Démarrer" },
        { nom: "Atelier Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Planning interventions", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Plomberie+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Gestion stock pièces", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Devis conformes DTU 60.1", "Gestion urgences 24/7", "Planning intelligent", "Stock pièces auto", "Support métier dédié"]
    },
    id: 'plombiers',
    nom: 'Plombiers',
    nomPluriel: 'plombiers',
    icon: 'Plumbing',
    couleurMetier: '#2196F3',
    
    hero: {
      titre: 'La solution LYS pour plombiers',
      soustitre: 'Gérez interventions, devis et urgences avec l\'expertise plomberie',
      badges: [
        '💧 +85% réactivité',
        '🚰 Devis conformes DTU',
        '🔧 3 200+ plombiers'
      ]
    },
    
    benefices: [
      {
        icon: 'Plumbing',
        titre: 'Devis plomberie automatiques',
        description: 'Canalisations, sanitaires, chauffage. Base complète DTU 60.1.',
        temoignage: 'Mes devis sont précis au centime'
      },
      {
        icon: 'Emergency',
        titre: 'Gestion urgences 24/7',
        description: 'Planning dépannages, interventions express, astreintes.',
        temoignage: 'Je réponds en 15 min aux urgences'
      },
      {
        icon: 'CalendarToday',
        titre: 'Planning optimisé',
        description: 'Tournées, interventions récurrentes, stock véhicule.',
        temoignage: '3 interventions de plus par jour'
      },
      {
        icon: 'Inventory',
        titre: 'Stock pièces plomberie',
        description: 'Robinets, joints, tuyaux. Réassort automatique.',
        temoignage: 'Plus jamais en rupture de joints'
      }
    ],
    
    temoignages: [
      {
        nom: 'Jean Robinet',
        entreprise: 'Plomberie JR',
        ville: 'Paris',
        avatar: 'JR',
        metier: 'Plombier dépannage',
        note: 5,
        chiffre: '+62% CA urgences',
        texte: 'La gestion urgences 24/7 a transformé mon business. Je traite 3x plus de dépannages !',
        resultats: {
          avant: '8 urgences/semaine',
          apres: '24 urgences/semaine',
          gain: '+200%'
        }
      },
      {
        nom: 'Paul Tuyau',
        entreprise: 'PT Plomberie',
        ville: 'Bordeaux',
        avatar: 'PT',
        metier: 'Plombier chauffagiste',
        note: 5,
        chiffre: '0 rupture stock',
        texte: 'Le stock automatique me fait économiser 2h/jour. Plus jamais bloqué pour un joint !',
        resultats: {
          avant: '5 ruptures/mois',
          apres: '0 rupture',
          gain: '-100%'
        }
      },
      {
        nom: 'Luc Sanitaire',
        entreprise: 'Sanitaire Plus',
        ville: 'Nice',
        avatar: 'LS',
        metier: 'Plombier installation',
        note: 5,
        chiffre: '12 chantiers/mois',
        texte: 'Le planning intelligent optimise mes tournées. 12 chantiers au lieu de 7 !',
        resultats: {
          avant: '7 chantiers/mois',
          apres: '12 chantiers/mois',
          gain: '+71%'
        }
      }
    ],
    
    fonctionnalites: [
      'Devis plomberie automatiques',
      'Gestion urgences 24/7',
      'Planning interventions',
      'Stock pièces détachées',
      'DTU 60.1 conformité',
      'Facturation dépannages',
      'Tournées optimisées',
      'Astreintes',
      'Fiches techniques',
      'Garanties installation',
      'Rappels entretien',
      'Base prix plomberie'
    ],
    
    stats: {
      utilisateurs: '3 200+',
      satisfaction: '97%',
      gainTemps: '+85%',
      conversions: '+142%'
    },
    
    seo: {
      title: 'LYS Plombiers - Logiciel Devis & Gestion Interventions Plomberie',
      description: 'Logiciel pour plombiers : devis conformes DTU, gestion urgences 24/7, planning interventions. 3 200+ plombiers nous font confiance.',
      keywords: 'logiciel plombier, devis plomberie, DTU 60.1, urgences plomberie, planning interventions'
    },
    b2bEnabled: true
  },

  garagistes: {
    b2b: {
      titre: "LYS B2B - L'atelier auto digital et performant",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité garagistes",
      roi: { timeToValue: "36h", clientsGain: "+75 clients garages", caSupplement: "+22% CA atelier", tempsGagne: "10h/sem gagnées" },
      pricing: [
        { nom: "Garage Solo", prix: "59€", periode: "/mois", features: ["1 utilisateur", "Devis mécanique auto", "Gestion stock pièces", "Support email"], cta: "Démarrer" },
        { nom: "Garage Pro", prix: "109€", periode: "/mois", features: ["5 utilisateurs", "Planning atelier optimisé", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Garage Réseau+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations DMS", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Devis mécanique auto", "Gestion stock pièces", "Planning atelier optimisé", "Alertes réassort", "Support métier dédié"]
    },
    id: 'garagistes',
    nom: 'Garagistes',
    nomPluriel: 'garagistes',
    icon: 'Build',
    couleurMetier: '#FF9800',
    
    hero: {
      titre: 'La solution LYS pour garagistes',
      soustitre: 'Gérez atelier, véhicules et pièces avec l\'expertise auto',
      badges: [
        '🔧 +85% efficacité',
        '🚗 Fiches complètes',
        '⚙️ 2 100+ garages'
      ]
    },
    
    benefices: [
      {
        icon: 'AssignmentTurnedIn',
        titre: 'Devis mécanique automatiques',
        description: 'Vidange, freins, distribution, embrayage. Base complète temps de main d\'œuvre.',
        temoignage: 'Mes devis sont 3x plus précis qu\'avant'
      },
      {
        icon: 'Inventory',
        titre: 'Gestion stock pièces auto',
        description: 'Suivi automatique plaquettes, filtres, huiles. Commandes fournisseurs intégrées.',
        temoignage: 'Plus jamais en rupture de plaquettes'
      },
      {
        icon: 'DirectionsCar',
        titre: 'Fiche véhicule complète',
        description: 'Historique interventions, prochaines révisions, rappels contrôle technique automatiques.',
        temoignage: 'Mes clients n\'oublient plus leur révision'
      },
      {
        icon: 'Build',
        titre: 'Planning atelier optimisé',
        description: 'Gestion ponts, équipes, urgences. Estimation temps réparation par type de véhicule.',
        temoignage: '2 voitures de plus par jour sur mes ponts'
      }
    ],
    
    temoignages: [
      {
        nom: 'Julien Moreau',
        entreprise: 'Garage Moreau',
        ville: 'Lille',
        avatar: 'JM',
        metier: 'Garagiste mécanique',
        note: 5,
        chiffre: '+58% CA',
        texte: 'Le planning intelligent optimise mes interventions par durée. Plus de temps mort, plus d\'attente. Mes clients sont ravis !',
        resultats: {
          avant: '6 véhicules/jour',
          apres: '12 véhicules/jour',
          gain: '+100%'
        }
      },
      {
        nom: 'Patrick Dufour',
        entreprise: 'Automeca Pro',
        ville: 'Strasbourg',
        avatar: 'PD',
        metier: 'Garagiste multimarques',
        note: 5,
        chiffre: '0 rupture stock',
        texte: 'LYS gère automatiquement mon stock pièces avec les références constructeurs. Alertes de réassort parfaites, fournisseurs intégrés !',
        resultats: {
          avant: '100% ruptures',
          apres: '0% ruptures',
          gain: '-100%'
        }
      },
      {
        nom: 'Michel Carbure',
        entreprise: 'Carburation Expert',
        ville: 'Nancy',
        avatar: 'MC',
        metier: 'Spécialiste carrosserie',
        note: 5,
        chiffre: 'x2.4 CA',
        texte: 'Grâce au réseau LYS, j\'ai ajouté la carrosserie. Mes clients ont un service complet : mécanique + peinture sous le même toit !',
        resultats: {
          avant: '7 800€/mois',
          apres: '18 500€/mois',
          gain: '+137%'
        }
      }
    ],
    
    fonctionnalites: [
      'Devis mécanique automatiques',
      'Gestion stock pièces auto',
      'Fiches véhicules complètes',
      'Planning atelier optimisé',
      'Temps main d\'œuvre',
      'Historique interventions',
      'Rappels révision',
      'Commandes fournisseurs',
      'Gestion ponts',
      'Références constructeurs',
      'Alertes réassort',
      'Facturation détaillée'
    ],
    
    stats: {
      utilisateurs: '2 100+',
      satisfaction: '96%',
      gainTemps: '+85%',
      conversions: '+138%'
    },
    
    seo: {
      title: 'LYS Garagistes - Logiciel Devis & Gestion Atelier Automobile',
      description: 'Logiciel pour garagistes : devis mécanique, stock pièces auto, planning atelier. 2 100+ garages nous font confiance.',
      keywords: 'logiciel garage, devis mécanique, stock pièces auto, planning atelier, gestion garage'
    },
    b2bEnabled: true
  },

  menuisiers: {
    b2b: {
      titre: "LYS B2B - La menuiserie connectée et optimisée",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité menuisiers",
      roi: { timeToValue: "60h", clientsGain: "+54 clients pros", caSupplement: "+19% CA atelier", tempsGagne: "6h/sem économisées" },
      pricing: [
        { nom: "Menuisier Solo", prix: "39€", periode: "/mois", features: ["1 utilisateur", "Plans & métrés auto", "Gestion stock bois", "Support email"], cta: "Démarrer" },
        { nom: "Atelier Pro", prix: "79€", periode: "/mois", features: ["5 utilisateurs", "Planning atelier/chantier", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Menuiserie+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations ERP", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Plans & métrés automatiques", "Gestion stock bois", "Planning atelier/chantier", "Devis sur mesure", "Support métier dédié"]
    },
    id: 'menuisiers',
    nom: 'Menuisiers',
    nomPluriel: 'menuisiers',
    icon: 'Carpenter',
    couleurMetier: '#8D6E63',
    b2bEnabled: true,
    
    hero: {
      titre: 'La solution LYS pour menuisiers',
      soustitre: 'Gérez fabrications, poses et chantiers bois avec précision',
      badges: ['🪵 +82% productivité', '📐 Plans 3D', '🔨 1 900+ menuisiers']
    },
    
    benefices: [
      { icon: 'Architecture', titre: 'Plans & métrés automatiques', description: 'Portes, fenêtres, escaliers, placards. Calculs matière optimisés.', temoignage: 'Plus d\'erreur de métré jamais' },
      { icon: 'Inventory', titre: 'Gestion stock bois', description: 'Essences, sections, longueurs. Chutes réutilisables.', temoignage: '20% économie sur le bois' },
      { icon: 'Construction', titre: 'Suivi fabrication/pose', description: 'Atelier + chantier. Double planning automatique.', temoignage: 'Atelier toujours occupé' },
      { icon: 'EuroSymbol', titre: 'Devis détaillés sur mesure', description: 'Bois, quincaillerie, finitions. Prix au m² ou forfait.', temoignage: 'Clients comprennent mes prix' }
    ],
    
    temoignages: [
      { nom: 'Antoine Bois', entreprise: 'Menuiserie AB', ville: 'Grenoble', avatar: 'AB', metier: 'Menuisier ébéniste', note: 5, chiffre: '+47% CA', texte: 'Les plans automatiques m\'ont permis de tripler mes devis. Mes clients visualisent tout avant !', resultats: { avant: '4 devis/semaine', apres: '12 devis/semaine', gain: '+200%' } },
      { nom: 'François Chêne', entreprise: 'Chêne & Co', ville: 'Annecy', avatar: 'FC', metier: 'Menuisier agencement', note: 5, chiffre: '0 perte matière', texte: 'La gestion chutes bois optimise mes découpes. 20% d\'économie matière !', resultats: { avant: '25% chutes', apres: '5% chutes', gain: '-80%' } },
      { nom: 'Marc Sapin', entreprise: 'Sapin Menuiserie', ville: 'Chambéry', avatar: 'MS', metier: 'Menuisier poseur', note: 5, chiffre: '3 chantiers/semaine', texte: 'Le double planning atelier + chantier synchronise tout. Mon équipe tourne à plein !', resultats: { avant: '1.5 chantier/sem', apres: '3 chantiers/sem', gain: '+100%' } }
    ],
    
    fonctionnalites: ['Plans automatiques', 'Métrés précis', 'Stock bois/essences', 'Gestion chutes', 'Planning atelier', 'Planning pose', 'Devis sur mesure', 'Quincaillerie', 'Finitions', 'Facturation détaillée', 'Calculs optimisés', 'Fiches techniques'],
    stats: { utilisateurs: '1 900+', satisfaction: '97%', gainTemps: '+82%', conversions: '+134%' },
    seo: { title: 'LYS Menuisiers - Logiciel Devis & Plans Menuiserie Bois', description: 'Logiciel menuisiers : plans automatiques, métrés, stock bois, planning atelier/pose. 1 900+ menuisiers.', keywords: 'logiciel menuisier, plans menuiserie, devis bois, gestion atelier' }
  },

  macons: {
    b2b: {
      titre: "LYS B2B - La maçonnerie digitale et robuste",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité maçons",
      roi: { timeToValue: "72h", clientsGain: "+61 clients chantiers", caSupplement: "+21% CA gros œuvre", tempsGagne: "7h/sem gagnées" },
      pricing: [
        { nom: "Maçon Solo", prix: "42€", periode: "/mois", features: ["1 utilisateur", "Métrés DTU 20.1", "Gestion matériaux", "Support email"], cta: "Démarrer" },
        { nom: "Équipe Pro", prix: "85€", periode: "/mois", features: ["5 utilisateurs", "Planning multi-chantiers", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Maçon+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations ERP", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Métrés DTU 20.1", "Gestion matériaux chantier", "Planning multi-chantiers", "Suivi conformité béton", "Support métier dédié"]
    },
    id: 'macons',
    nom: 'Maçons',
    nomPluriel: 'maçons',
    icon: 'HomeRepairService',
    couleurMetier: '#9E9E9E',
    b2bEnabled: true,
    
    hero: {
      titre: 'La solution LYS pour maçons',
      soustitre: 'Gérez chantiers, matériaux et équipes avec robustesse',
      badges: ['🏗️ +78% efficacité', '🧱 Métrés DTU', '👷 2 500+ maçons']
    },
    
    benefices: [
      { icon: 'Construction', titre: 'Métrés maçonnerie automatiques', description: 'Fondations, murs, dalles. Conformité DTU 20.1.', temoignage: 'Métrés validés au premier coup' },
      { icon: 'LocalShipping', titre: 'Gestion matériaux chantier', description: 'Parpaings, ciment, sable, fer. Livraisons coordonnées.', temoignage: 'Plus jamais en rupture ciment' },
      { icon: 'Groups', titre: 'Planning équipes multi-chantiers', description: 'Compagnons, grutiers, engins. Rotation optimisée.', temoignage: 'Mes 3 équipes tournent sans arrêt' },
      { icon: 'CheckCircle', titre: 'Suivi conformité béton', description: 'Tests résistance, certificats agrégats, traçabilité.', temoignage: 'Bureau contrôle toujours OK' }
    ],
    
    temoignages: [
      { nom: 'Bruno Béton', entreprise: 'Maçonnerie BB', ville: 'Nantes', avatar: 'BB', metier: 'Maçon VRD', note: 5, chiffre: '+52% CA', texte: 'Le planning multi-équipes m\'a permis de doubler mes chantiers sans chaos !', resultats: { avant: '2 chantiers simult.', apres: '5 chantiers simult.', gain: '+150%' } },
      { nom: 'Daniel Pierre', entreprise: 'Pierre Maçonnerie', ville: 'Rennes', avatar: 'DP', metier: 'Maçon bâtiment', note: 5, chiffre: '0 rupture', texte: 'LYS synchronise mes livraisons matériaux. Chantier jamais à l\'arrêt !', resultats: { avant: '4 ruptures/mois', apres: '0 rupture', gain: '-100%' } },
      { nom: 'Jean Ciment', entreprise: 'Ciment Pro', ville: 'Le Mans', avatar: 'JC', metier: 'Maçon gros œuvre', note: 5, chiffre: 'x2.1 chantiers', texte: 'Métrés automatiques DTU 20.1 rassurent mes clients. Signature immédiate !', resultats: { avant: '3 chantiers/mois', apres: '6.3 chantiers/mois', gain: '+110%' } }
    ],
    
    fonctionnalites: ['Métrés maçonnerie', 'DTU 20.1 conformité', 'Gestion matériaux', 'Planning équipes', 'Livraisons coordonnées', 'Tests béton', 'Certificats agrégats', 'Suivi engins', 'Facturation détaillée', 'Traçabilité', 'Devis gros œuvre', 'Planning chantiers'],
    stats: { utilisateurs: '2 500+', satisfaction: '96%', gainTemps: '+78%', conversions: '+129%' },
    seo: { title: 'LYS Maçons - Logiciel Devis & Gestion Chantiers Maçonnerie', description: 'Logiciel maçons : métrés DTU, gestion matériaux, planning équipes. 2 500+ maçons.', keywords: 'logiciel maçon, métrés maçonnerie, DTU 20.1, gestion chantiers' }
  },

  carreleurs: {
    id: 'carreleurs',
    nom: 'Carreleurs',
    nomPluriel: 'carreleurs',
    icon: 'GridOn',
    couleurMetier: '#607D8B',
    
    hero: {
      titre: 'La solution LYS pour carreleurs',
      soustitre: 'Gérez poses, calepinages et chantiers avec précision',
      badges: ['🔲 +80% rapidité', '📐 Calepinages auto', '🏠 1 600+ carreleurs']
    },
    
    benefices: [
      { icon: 'GridOn', titre: 'Calepinages automatiques', description: 'Calculs m², pertes, joints, plinthes. Plans de pose optimisés.', temoignage: 'Calepinages en 2 min au lieu de 30' },
      { icon: 'Palette', titre: 'Catalogues carrelage', description: 'Milliers références, visualisation 3D, simulation client.', temoignage: 'Clients choisissent direct avec visuel' },
      { icon: 'Construction', titre: 'Devis pose détaillés', description: 'Sol, mur, faïence. Ragréage, colle, joints inclus.', temoignage: 'Devis hyper détaillés, zéro contestation' },
      { icon: 'Inventory', titre: 'Stock carreaux/fournitures', description: 'Carreaux, colle, joints. Réassort par chantier.', temoignage: 'Plus jamais en manque de colle' }
    ],
    
    temoignages: [
      { nom: 'Olivier Pose', entreprise: 'Carrelage OP', ville: 'Toulouse', avatar: 'OP', metier: 'Carreleur sol/mur', note: 5, chiffre: '+64% CA', texte: 'Les calepinages auto ont triplé ma vitesse de devis. Je signe 2x plus !', resultats: { avant: '6 devis/semaine', apres: '18 devis/semaine', gain: '+200%' } },
      { nom: 'Thierry Carreau', entreprise: 'TC Faïence', ville: 'Montpellier', avatar: 'TC', metier: 'Carreleur faïence', note: 5, chiffre: '0 erreur métré', texte: 'Les calculs précis éliminent mes pertes matière. 15% économie !', resultats: { avant: '20% pertes', apres: '5% pertes', gain: '-75%' } },
      { nom: 'Alain Mosaïque', entreprise: 'Mosaïque Art', ville: 'Nice', avatar: 'AM', metier: 'Carreleur mosaïste', note: 5, chiffre: '4 chantiers/semaine', texte: 'Le planning optimisé me fait gagner 2 chantiers par semaine. Mon équipe tourne parfaitement !', resultats: { avant: '2 chantiers/sem', apres: '4 chantiers/sem', gain: '+100%' } }
    ],
    
    fonctionnalites: ['Calepinages auto', 'Calculs m² précis', 'Catalogues carrelage', 'Visualisation 3D', 'Devis pose détaillés', 'Stock carreaux', 'Gestion fournitures', 'Planning chantiers', 'Ragréage/colle/joints', 'Plinthes auto', 'Facturation', 'Fiches techniques'],
    stats: { utilisateurs: '1 600+', satisfaction: '98%', gainTemps: '+80%', conversions: '+141%' },
    seo: { title: 'LYS Carreleurs - Logiciel Devis & Calepinages Carrelage', description: 'Logiciel carreleurs : calepinages automatiques, calculs m², catalogues. 1 600+ carreleurs.', keywords: 'logiciel carreleur, calepinage, devis carrelage, calcul m²' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - Le carrelage connecté et rentable",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité carrelage",
      roi: { timeToValue: "60h", clientsGain: "+85 clients fidélisés", caSupplement: "+25% CA", tempsGagne: "7h/sem gagnées" },
      pricing: [
        { nom: "Carreleur Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Calepinages auto", "Devis détaillés", "Support email"], cta: "Démarrer" },
        { nom: "Équipe Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Planning chantiers", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Carrelage+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Gestion stock carreaux", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Calepinages automatiques", "Calculs m² précis", "Devis conformes DTU", "Stock carreaux intelligent", "Support métier dédié"]
    }
  },

  couvreurs: {
    id: 'couvreurs',
    nom: 'Couvreurs',
    nomPluriel: 'couvreurs',
    icon: 'Roofing',
    couleurMetier: '#795548',
    b2bEnabled: true,
    
    hero: {
      titre: 'La solution LYS pour couvreurs',
      soustitre: 'Gérez toitures, matériaux et chantiers en hauteur',
      badges: ['🏠 +76% productivité', '📐 Métrés toiture', '☂️ 1 400+ couvreurs']
    },
    
    benefices: [
      { icon: 'Roofing', titre: 'Métrés toiture automatiques', description: 'Tuiles, ardoises, zinc. Surface, pentes, gouttières calculées.', temoignage: 'Métrés toiture en 5 min chrono' },
      { icon: 'Cloud', titre: 'Conformité DTU 40', description: 'Ventilation, étanchéité, isolation. Certificats générés.', temoignage: 'Bureau contrôle valide direct' },
      { icon: 'Inventory', titre: 'Stock matériaux couverture', description: 'Tuiles, liteaux, écrans, gouttières. Livraison chantier.', temoignage: 'Plus jamais en manque de tuiles' },
      { icon: 'Schedule', titre: 'Planning météo intégré', description: 'Reports auto pluie, optimisation fenêtres météo.', temoignage: 'Chantier jamais bloqué par surprise' }
    ],
    
    temoignages: [
      { nom: 'Claude Tuile', entreprise: 'Couverture CT', ville: 'Clermont-Ferrand', avatar: 'CT', metier: 'Couvreur toiture', note: 5, chiffre: '+58% CA', texte: 'Les métrés auto tuiles/liteaux sont d\'une précision folle. Clients signent immédiatement !', resultats: { avant: '5 devis/semaine', apres: '13 devis/semaine', gain: '+160%' } },
      { nom: 'René Ardoise', entreprise: 'Ardoise Pro', ville: 'Angers', avatar: 'RA', metier: 'Couvreur ardoisier', note: 5, chiffre: '0 non-conformité', texte: 'DTU 40 automatique élimine les erreurs. Bureau contrôle ne me reprend jamais !', resultats: { avant: '2 reprises/mois', apres: '0 reprise', gain: '-100%' } },
      { nom: 'Gérard Zinc', entreprise: 'Zinc Couverture', ville: 'Tours', avatar: 'GZ', metier: 'Couvreur zingueur', note: 5, chiffre: '3 toitures/semaine', texte: 'Planning météo évite les annulations. Mes équipes travaillent sans interruption !', resultats: { avant: '1.5 toiture/sem', apres: '3 toitures/sem', gain: '+100%' } }
    ],
    
    fonctionnalites: ['Métrés toiture auto', 'Calculs pentes', 'DTU 40 conformité', 'Stock matériaux', 'Planning météo', 'Tuiles/ardoises/zinc', 'Gouttières/écrans', 'Ventilation/étanchéité', 'Devis détaillés', 'Facturation', 'Livraison chantier', 'Certificats'],
    stats: { utilisateurs: '1 400+', satisfaction: '97%', gainTemps: '+76%', conversions: '+136%' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - La couverture connectée et rentable",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité couverture",
      roi: { timeToValue: "50h", clientsGain: "+76 clients fidélisés", caSupplement: "+22% CA", tempsGagne: "6h/sem gagnées" },
      pricing: [
        { nom: "Couvreur Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Métrés toiture auto", "DTU 40 conformité", "Support email"], cta: "Démarrer" },
        { nom: "Équipe Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Planning chantiers", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Couverture+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Gestion stock matériaux", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Métrés toiture automatiques", "Conformité DTU 40", "Planning météo intégré", "Stock matériaux intelligent", "Support métier dédié"]
    },
    seo: { title: 'LYS Couvreurs - Logiciel Devis & Métrés Toiture Couverture', description: 'Logiciel couvreurs : métrés toiture, DTU 40, stock matériaux. 1 400+ couvreurs.', keywords: 'logiciel couvreur, métré toiture, DTU 40, devis couverture' }
  },

  peintres: {
    id: 'peintres',
    nom: 'Peintres',
    nomPluriel: 'peintres',
    icon: 'FormatPaint',
    couleurMetier: '#E91E63',
    
    hero: {
      titre: 'La solution LYS pour peintres',
      soustitre: 'Gérez surfaces, couleurs et chantiers avec créativité',
      badges: ['🎨 +83% rapidité', '🖌️ Nuanciers intégrés', '🏠 2 200+ peintres']
    },
    
    benefices: [
      { icon: 'FormatPaint', titre: 'Calculs surfaces automatiques', description: 'Murs, plafonds, boiseries. Nombre couches, rendement peinture.', temoignage: 'Calculs précis, zéro erreur quantité' },
      { icon: 'Palette', titre: 'Nuanciers digitaux', description: 'RAL, NCS, Pantone. Simulation couleurs client 3D.', temoignage: 'Clients visualisent avant travaux' },
      { icon: 'Inventory', titre: 'Stock peintures/matériel', description: 'Peintures, sous-couches, pinceaux. Réassort auto.', temoignage: 'Plus jamais en manque blanc cassé' },
      { icon: 'EuroSymbol', titre: 'Devis pose détaillés', description: 'Préparation, sous-couche, finition. Prix au m² clair.', temoignage: 'Clients comprennent mes tarifs' }
    ],
    
    temoignages: [
      { nom: 'Pascal Couleur', entreprise: 'Peinture PC', ville: 'Lyon', avatar: 'PC', metier: 'Peintre bâtiment', note: 5, chiffre: '+71% CA', texte: 'Les calculs auto m²/litres ont doublé ma vitesse devis. Je signe 3x plus !', resultats: { avant: '8 devis/semaine', apres: '24 devis/semaine', gain: '+200%' } },
      { nom: 'Michel Nuance', entreprise: 'Nuance Peinture', ville: 'Marseille', avatar: 'MN', metier: 'Peintre décorateur', note: 5, chiffre: '0 erreur teinte', texte: 'Nuanciers digitaux éliminent les erreurs teinte. Satisfaction client 100% !', resultats: { avant: '3 erreurs/mois', apres: '0 erreur', gain: '-100%' } },
      { nom: 'André Brosse', entreprise: 'Brosse Pro', ville: 'Bordeaux', avatar: 'AB', metier: 'Peintre ravalement', note: 5, chiffre: '5 chantiers/semaine', texte: 'Stock automatique optimise mes achats. 18% économie peinture !', resultats: { avant: '3 chantiers/sem', apres: '5 chantiers/sem', gain: '+67%' } }
    ],
    
    fonctionnalites: ['Calculs surfaces auto', 'Nombre couches', 'Nuanciers RAL/NCS', 'Simulation 3D', 'Devis détaillés', 'Stock peintures', 'Sous-couches/finitions', 'Planning chantiers', 'Rendement peinture', 'Facturation', 'Boiseries/murs/plafonds', 'Fiches techniques'],
    stats: { utilisateurs: '2 200+', satisfaction: '98%', gainTemps: '+83%', conversions: '+147%' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - La peinture connectée et rentable",
      soustitre: "La plateforme tout-en-un pour développer et gérer votre activité peinture",
      roi: { timeToValue: "55h", clientsGain: "+80 clients fidélisés", caSupplement: "+24% CA", tempsGagne: "6.5h/sem gagnées" },
      pricing: [
        { nom: "Peintre Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Calculs surfaces auto", "Nuanciers intégrés", "Support email"], cta: "Démarrer" },
        { nom: "Équipe Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Planning chantiers", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Peinture+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Gestion stock peintures", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Calculs surfaces automatiques", "Nuanciers RAL/NCS", "Simulation 3D", "Stock peintures intelligent", "Support métier dédié"]
    },
    seo: { title: 'LYS Peintres - Logiciel Devis & Calculs Surfaces Peinture', description: 'Logiciel peintres : calculs surfaces, nuanciers, stock peintures. 2 200+ peintres.', keywords: 'logiciel peintre, calcul surface, nuancier, devis peinture' },
    b2bEnabled: true
  },

  jardiniers: {
    id: 'jardiniers',
    nom: 'Jardiniers',
    nomPluriel: 'jardiniers',
    icon: 'Grass',
    couleurMetier: '#4CAF50',
    b2bEnabled: true,
    
    hero: {
      titre: 'La solution LYS pour jardiniers',
      soustitre: 'Gérez espaces verts, entretiens et clients avec sérénité',
      badges: ['🌱 +77% efficacité', '🌳 Planning récurrent', '🏡 1 800+ jardiniers']
    },
    
    benefices: [
      { icon: 'Grass', titre: 'Planning entretiens récurrents', description: 'Tonte, taille, débroussaillage. Tournées optimisées automatiques.', temoignage: 'Mes tournées sont parfaites toute l\'année' },
      { icon: 'WbSunny', titre: 'Météo intégrée', description: 'Reports automatiques pluie, alertes canicule arrosage.', temoignage: 'Plus jamais bloqué par météo surprise' },
      { icon: 'Inventory', titre: 'Stock matériel/plantes', description: 'Semences, engrais, outils. Suivi entretien matériel.', temoignage: 'Matériel toujours opérationnel' },
      { icon: 'CalendarMonth', titre: 'Contrats annuels', description: 'Facturation mensuelle auto, renouvellements rappelés.', temoignage: 'Revenus récurrents garantis' }
    ],
    
    temoignages: [
      { nom: 'Pierre Vert', entreprise: 'Jardin PV', ville: 'Aix-en-Provence', avatar: 'PV', metier: 'Jardinier paysagiste', note: 5, chiffre: '+82% clients récurrents', texte: 'Les contrats annuels automatiques ont stabilisé mon CA. Revenus prévisibles !', resultats: { avant: '40% récurrent', apres: '82% récurrent', gain: '+105%' } },
      { nom: 'Jean Gazon', entreprise: 'Gazon Plus', ville: 'Cannes', avatar: 'JG', metier: 'Jardinier entretien', note: 5, chiffre: '35 jardins/semaine', texte: 'Tournées optimisées me font gagner 2h/jour. 35 jardins au lieu de 25 !', resultats: { avant: '25 jardins/sem', apres: '35 jardins/sem', gain: '+40%' } },
      { nom: 'Marc Feuille', entreprise: 'Espace Vert MF', ville: 'Toulon', avatar: 'MF', metier: 'Jardinier créateur', note: 5, chiffre: 'x2.3 CA', texte: 'Planning météo évite les annulations. Mes équipes travaillent tous les jours !', resultats: { avant: '12 000€/mois', apres: '27 600€/mois', gain: '+130%' } }
    ],
    
    fonctionnalites: ['Planning récurrents', 'Tournées optimisées', 'Météo intégrée', 'Contrats annuels', 'Facturation mensuelle', 'Stock matériel/plantes', 'Entretien outils', 'Devis paysagisme', 'Suivi arrosage', 'Rappels taille', 'Alertes canicule', 'Fiches végétaux'],
    stats: { utilisateurs: '1 800+', satisfaction: '96%', gainTemps: '+77%', conversions: '+128%' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - Le jardinage connecte et rentable",
      soustitre: "La plateforme tout-en-un pour developper et gerer votre activite jardinage",
      roi: { timeToValue: "65h", clientsGain: "+92 clients fidelises", caSupplement: "+28% CA", tempsGagne: "7.5h/sem gagnees" },
      pricing: [
        { nom: "Jardinier Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Planning recurrents", "Contrats annuels", "Support email"], cta: "Demarrer" },
        { nom: "Equipe Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Planning chantiers", "Analytics avances", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Jardinage+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimites", "Multi-sites", "Gestion equipes mobiles", "Formation equipe"], cta: "Nous contacter" }
      ],
      arguments: ["Planning recurrents intelligents", "Contrats annuels generes", "Planning meteo integre", "Gestion equipes mobiles", "Support metier dedie"]
    },
    seo: { title: 'LYS Jardiniers - Logiciel Planning & Contrats Espaces Verts', description: 'Logiciel jardiniers : planning récurrents, météo, contrats annuels. 1 800+ jardiniers.', keywords: 'logiciel jardinier, planning entretien, contrats jardinage, tournées' },
    b2bEnabled: true
  },

  ramoneurs: {
    id: 'ramoneurs',
    nom: 'Ramoneurs',
    nomPluriel: 'ramoneurs',
    icon: 'FirePlace',
    couleurMetier: '#424242',
    
    hero: {
      titre: 'La solution LYS pour ramoneurs',
      soustitre: 'Gérez ramonages, certificats et clients avec rigueur',
      badges: ['🔥 +74% organisation', '📜 Certificats auto', '🏠 950+ ramoneurs']
    },
    
    benefices: [
      { icon: 'Article', titre: 'Certificats ramonage automatiques', description: 'Conformes assurances, horodatage, signature électronique.', temoignage: 'Certificats impeccables validés assurances' },
      { icon: 'CalendarMonth', titre: 'Rappels annuels clients', description: 'Email/SMS automatique avant échéance obligatoire.', temoignage: '80% clients reviennent automatiquement' },
      { icon: 'Inventory', titre: 'Stock matériel ramonage', description: 'Hérissons, brosses, aspirateurs. Entretien équipement.', temoignage: 'Matériel toujours prêt' },
      { icon: 'Route', titre: 'Tournées optimisées', description: 'Planning géographique, minimisation trajets.', temoignage: '3 ramonages de plus par jour' }
    ],
    
    temoignages: [
      { nom: 'Henri Suie', entreprise: 'Ramonage HS', ville: 'Chambéry', avatar: 'HS', metier: 'Ramoneur certifié', note: 5, chiffre: '80% fidélisation', texte: 'Rappels automatiques ramènent 80% clients chaque année. Fidélité parfaite !', resultats: { avant: '45% fidélisation', apres: '80% fidélisation', gain: '+78%' } },
      { nom: 'Robert Cheminée', entreprise: 'Cheminée Pro', ville: 'Annecy', avatar: 'RC', metier: 'Ramoneur poêles', note: 5, chiffre: '12 ramonages/jour', texte: 'Tournées optimisées géographiquement doublent ma productivité !', resultats: { avant: '6 ramonages/jour', apres: '12 ramonages/jour', gain: '+100%' } },
      { nom: 'Michel Conduit', entreprise: 'Conduit Clean', ville: 'Grenoble', avatar: 'MC', metier: 'Ramoneur insert', note: 5, chiffre: '0 refus assurance', texte: 'Certificats automatiques conformes éliminent les litiges assurances !', resultats: { avant: '2 litiges/mois', apres: '0 litige', gain: '-100%' } }
    ],
    
    fonctionnalites: ['Certificats auto conformes', 'Rappels annuels', 'Email/SMS clients', 'Tournées optimisées', 'Stock matériel', 'Entretien équipement', 'Signature électronique', 'Devis ramonage', 'Facturation', 'Horodatage', 'Planning géographique', 'Fiches techniques'],
    stats: { utilisateurs: '950+', satisfaction: '97%', gainTemps: '+74%', conversions: '+122%' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - Le ramonage connecte et securise",
      soustitre: "La plateforme tout-en-un pour developper et gerer votre activite ramonage",
      roi: { timeToValue: "40h", clientsGain: "+56 clients fidelises", caSupplement: "+20% CA", tempsGagne: "5h/sem gagnees" },
      pricing: [
        { nom: "Ramoneur Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Certificats auto", "Rappels clients", "Support email"], cta: "Demarrer" },
        { nom: "Equipe Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Planning tournees", "Analytics avances", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Ramonage+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimites", "Multi-sites", "Gestion equipes", "Formation equipe"], cta: "Nous contacter" }
      ],
      arguments: ["Certificats ramonage automatiques", "Rappels clients intelligents", "Planning tournees optimise", "Historique ramonages securise", "Support metier dedie"]
    },
    seo: { title: 'LYS Ramoneurs - Logiciel Certificats & Planning Ramonage', description: 'Logiciel ramoneurs : certificats automatiques, rappels clients, tournées. 950+ ramoneurs.', keywords: 'logiciel ramoneur, certificat ramonage, rappels clients, planning' },
    b2bEnabled: true
  },

  coiffeurs: {
    id: 'coiffeurs',
    nom: 'Coiffeurs',
    nomPluriel: 'coiffeurs',
    icon: 'ContentCut',
    couleurMetier: '#9C27B0',
    b2b: {
      titre: "LYS B2B - La coiffure connectée et rentable",
      roi: { timeToValue: "48h", clientsGain: "+120 clients fidélisés", caSupplement: "+30% CA", tempsGagne: "10h/sem économisées" },
      pricing: [
        { nom: "Coiffeur Solo", prix: "39€", periode: "/mois", features: ["1 utilisateur", "Planning RDV", "Facturation rapide", "Support email"], cta: "Démarrer" },
        { nom: "Salon Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Gestion multi-salons", "Analytics avancés", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Coiffure+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimités", "Multi-sites", "Intégrations ERP", "Formation équipe"], cta: "Nous contacter" }
      ],
      arguments: ["Planning intelligent", "Facturation simplifiée", "Gestion multi-salons", "Support métier dédié"]
    },
    hero: {
      titre: 'La solution LYS pour coiffeurs',
      soustitre: 'Gérez salon, rendez-vous et clients avec élégance',
      badges: ['💇 +88% réservations', '📅 Planning en ligne', '✂️ 3 400+ salons']
    },
    
    benefices: [
      { icon: 'EventAvailable', titre: 'Réservation en ligne 24/7', description: 'Clients réservent sur site web, confirmation auto SMS/email.', temoignage: '70% rdv viennent du site maintenant' },
      { icon: 'Person', titre: 'Fiches clients complètes', description: 'Historique coupes, colorations, préférences, photos avant/après.', temoignage: 'Je retrouve tout l\'historique instantanément' },
      { icon: 'Inventory2', titre: 'Stock produits salon', description: 'Shampoings, colorations, soins. Alertes réassort.', temoignage: 'Plus jamais en rupture coloration' },
      { icon: 'TrendingUp', titre: 'Statistiques CA/coiffeur', description: 'Performance équipe, services populaires, heures creuses.', temoignage: 'J\'optimise mon planning grâce aux stats' }
    ],
    
    temoignages: [
      { nom: 'Sophie Style', entreprise: 'Salon Sophie', ville: 'Paris 11e', avatar: 'SS', metier: 'Coiffeuse visagiste', note: 5, chiffre: '+124% rdv en ligne', texte: 'Réservation 24/7 a explosé ma fréquentation. Salon plein du matin au soir !', resultats: { avant: '45 rdv/semaine', apres: '101 rdv/semaine', gain: '+124%' } },
      { nom: 'Caroline Coupe', entreprise: 'Cut & Color', ville: 'Lyon 6e', avatar: 'CC', metier: 'Coiffeuse coloriste', note: 5, chiffre: '0 oubli formule', texte: 'Fiches clients gardent toutes mes formules coloration. Résultat parfait à chaque fois !', resultats: { avant: '3 erreurs/mois', apres: '0 erreur', gain: '-100%' } },
      { nom: 'Julie Brushing', entreprise: 'Brushing Pro', ville: 'Marseille', avatar: 'JB', metier: 'Coiffeuse mariages', note: 5, chiffre: 'x2.8 CA', texte: 'Stats me montrent les créneaux rentables. J\'ai réorganisé et doublé mon CA !', resultats: { avant: '8 500€/mois', apres: '23 800€/mois', gain: '+180%' } }
    ],
    
    fonctionnalites: ['Réservation en ligne', 'Planning salon', 'SMS/email confirmation', 'Fiches clients', 'Historique coupes/colorations', 'Stock produits', 'Caisse encaissement', 'Statistiques CA', 'Photos avant/après', 'Alertes réassort', 'Gestion équipe', 'Rappels rdv'],
    stats: { utilisateurs: '3 400+', satisfaction: '98%', gainTemps: '+88%', conversions: '+167%' },
    seo: { title: 'LYS Coiffeurs - Logiciel Réservation & Gestion Salon Coiffure', description: 'Logiciel coiffeurs : réservation en ligne, planning, fiches clients. 3 400+ salons.', keywords: 'logiciel coiffeur, réservation salon, planning coiffure, gestion salon' },
    b2bEnabled: true
  },

  estheticiennes: {
    id: 'estheticiennes',
    nom: 'Esthéticiens',
    nomPluriel: 'esthéticiens',
    icon: 'Spa',
    couleurMetier: '#E91E63',
    
    hero: {
      titre: 'La solution LYS pour esthéticiens',
      soustitre: 'Gérez institut, soins et clients avec douceur',
      badges: ['💆 +85% réservations', '🌸 Planning en ligne', '✨ 2 900+ instituts']
    },
    
    benefices: [
      { icon: 'CalendarMonth', titre: 'Réservation soins en ligne', description: 'Épilations, massages, soins visage. Paiement en ligne possible.', temoignage: '75% rdv via le site maintenant' },
      { icon: 'FaceRetouchingNatural', titre: 'Fiches clients beauté', description: 'Type peau, allergies, protocoles soins, résultats.', temoignage: 'Je personnalise chaque soin parfaitement' },
      { icon: 'ShoppingCart', titre: 'Vente produits cosmétiques', description: 'Stock cosmétiques, vente comptoir, programmes fidélité.', temoignage: '+40% CA produits grâce au suivi' },
      { icon: 'Notifications', titre: 'Rappels soins réguliers', description: 'SMS automatiques épilations, soins mensuels.', temoignage: '65% clients reviennent régulièrement' }
    ],
    
    temoignages: [
      { nom: 'Nathalie Beauté', entreprise: 'Institut NB', ville: 'Cannes', avatar: 'NB', metier: 'Esthéticienne soins', note: 5, chiffre: '+118% rdv', texte: 'Réservation en ligne a doublé ma fréquentation. Institut complet 3 semaines à l\'avance !', resultats: { avant: '38 soins/semaine', apres: '83 soins/semaine', gain: '+118%' } },
      { nom: 'Isabelle Spa', entreprise: 'Spa Wellness', ville: 'Nice', avatar: 'IS', metier: 'Esthéticienne spa', note: 5, chiffre: '+40% CA produits', texte: 'Suivi ventes cosmétiques a boosté mon CA produits. Recommandations personnalisées !', resultats: { avant: '1 200€/mois', apres: '1 680€/mois', gain: '+40%' } },
      { nom: 'Sylvie Épil', entreprise: 'Épilation Pro', ville: 'Antibes', avatar: 'SE', metier: 'Esthéticienne épilation', note: 5, chiffre: '65% fidélisation', texte: 'Rappels SMS automatiques ramènent mes clientes régulièrement. Fidélité parfaite !', resultats: { avant: '35% fidélisation', apres: '65% fidélisation', gain: '+86%' } }
    ],
    
    fonctionnalites: ['Réservation en ligne', 'Planning soins', 'Fiches clients beauté', 'Type peau/allergies', 'Vente cosmétiques', 'Stock produits', 'Programmes fidélité', 'Rappels SMS', 'Paiement en ligne', 'Caisse', 'Statistiques CA', 'Photos avant/après'],
    stats: { utilisateurs: '2 900+', satisfaction: '97%', gainTemps: '+85%', conversions: '+152%' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - La beaute connectee et rentable",
      soustitre: "La plateforme tout-en-un pour developper et gerer votre institut de beaute",
      roi: { timeToValue: "48h", clientsGain: "+102 clients fidelises", caSupplement: "+32% CA", tempsGagne: "8h/sem gagnees" },
      pricing: [
        { nom: "Institut Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Reservation soins", "Fiches clients", "Support email"], cta: "Demarrer" },
        { nom: "Institut Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Gestion produits", "Analytics avances", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Beaute+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimites", "Multi-sites", "Gestion stocks cosmetiques", "Formation equipe"], cta: "Nous contacter" }
      ],
      arguments: ["Reservation soins automatiques", "Fiches clients beaute completes", "Gestion stocks cosmetiques", "Fidelisation clients avancee", "Support metier dedie"]
    },
    seo: { title: 'LYS Esthéticiens - Logiciel Réservation & Gestion Institut Beauté', description: 'Logiciel esthéticiens : réservation soins, fiches clients, vente cosmétiques. 2 900+ instituts.', keywords: 'logiciel esthéticienne, réservation soins, gestion institut, planning beauté' },
    b2bEnabled: true
  },

  fleuristes: {
    id: 'fleuristes',
    nom: 'Fleuristes',
    nomPluriel: 'fleuristes',
    icon: 'LocalFlorist',
    couleurMetier: '#FF4081',
    
    hero: {
      titre: 'La solution LYS pour fleuristes',
      soustitre: 'Gérez boutique, commandes et livraisons avec fraîcheur',
      badges: ['🌹 +79% commandes', '🚚 Livraisons optimisées', '💐 1 700+ fleuristes']
    },
    
    benefices: [
      { icon: 'ShoppingCart', titre: 'Boutique en ligne fleurs', description: 'Catalogue compositions, commande web, paiement sécurisé.', temoignage: '60% commandes viennent du site' },
      { icon: 'LocalShipping', titre: 'Planning livraisons', description: 'Tournées optimisées géographiquement, créneaux horaires.', temoignage: '8 livraisons de plus par jour' },
      { icon: 'Inventory', titre: 'Stock fleurs fraîches', description: 'Roses, lys, orchidées. Alertes péremption, commandes fournisseurs.', temoignage: '30% moins de pertes fraîcheur' },
      { icon: 'Event', titre: 'Gestion événements', description: 'Mariages, deuil, entreprises. Devis personnalisés, rappels.', temoignage: 'Mes mariages sont parfaitement organisés' }
    ],
    
    temoignages: [
      { nom: 'Marie Pétale', entreprise: 'Fleurs MP', ville: 'Versailles', avatar: 'MP', metier: 'Fleuriste créatrice', note: 5, chiffre: '+92% web', texte: 'Boutique en ligne a presque doublé mon CA. Commandes 24/7 même fermé !', resultats: { avant: '1 200€/semaine web', apres: '2 304€/semaine web', gain: '+92%' } },
      { nom: 'Florence Rose', entreprise: 'Rose & Co', ville: 'Saint-Germain', avatar: 'FR', metier: 'Fleuriste événements', note: 5, chiffre: '12 mariages/mois', texte: 'Gestion événements centralise tout : devis, livraison, suivi. Zéro stress !', resultats: { avant: '6 mariages/mois', apres: '12 mariages/mois', gain: '+100%' } },
      { nom: 'Lucie Bouquet', entreprise: 'Bouquet Express', ville: 'Neuilly', avatar: 'LB', metier: 'Fleuriste livraison', note: 5, chiffre: '25 livraisons/jour', texte: 'Tournées optimisées me font gagner 2h/jour. 25 livraisons au lieu de 17 !', resultats: { avant: '17 livraisons/jour', apres: '25 livraisons/jour', gain: '+47%' } }
    ],
    
    fonctionnalites: ['Boutique en ligne', 'Catalogue compositions', 'Planning livraisons', 'Tournées optimisées', 'Stock fleurs fraîches', 'Alertes péremption', 'Gestion événements', 'Devis mariages', 'Commandes fournisseurs', 'Paiement en ligne', 'Caisse', 'Rappels événements'],
    stats: { utilisateurs: '1 700+', satisfaction: '96%', gainTemps: '+79%', conversions: '+139%' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - Les fleurs connectees et rentables",
      soustitre: "La plateforme tout-en-un pour developper et gerer votre boutique fleurs",
      roi: { timeToValue: "52h", clientsGain: "+78 clients fidelises", caSupplement: "+26% CA", tempsGagne: "7h/sem gagnees" },
      pricing: [
        { nom: "Fleuriste Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Boutique en ligne", "Planning livraisons", "Support email"], cta: "Demarrer" },
        { nom: "Boutique Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Gestion stocks", "Analytics avances", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Fleurs+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimites", "Multi-sites", "Gestion fournisseurs", "Formation equipe"], cta: "Nous contacter" }
      ],
      arguments: ["Boutique fleurs en ligne", "Planning livraisons optimise", "Gestion stocks fraicheur", "Calendrier fetes intelligent", "Support metier dedie"]
    },
    seo: { title: 'LYS Fleuristes - Logiciel Boutique en Ligne & Livraisons Fleurs', description: 'Logiciel fleuristes : boutique web, planning livraisons, stock fleurs. 1 700+ fleuristes.', keywords: 'logiciel fleuriste, boutique en ligne fleurs, livraisons, stock fleurs' },
    b2bEnabled: true
  },

  // carrossiers: {
  //   id: 'carrossiers',
  //   nom: 'Carrossiers',
  //   nomPluriel: 'carrossiers',
  //   icon: 'DirectionsCar',
  //   couleurMetier: '#FF5722',
  //   hero: {
  //     titre: 'La solution LYS pour carrossiers',
  //     soustitre: 'Gérez réparations, peinture et assurances avec précision',
  //     badges: ['🚗 +81% efficacité', '🎨 Teintométrie', '💼 1 500+ carrossiers']
  //   },
  //   benefices: [
  //     { icon: 'Assessment', titre: 'Devis carrosserie/peinture', description: 'Débosselage, peinture, remplacement. Temps main d\'œuvre auto.', temoignage: 'Devis précis acceptés assurances' },
  //     { icon: 'Palette', titre: 'Teintométrie intégrée', description: 'Codes couleur constructeurs, formulation peinture auto.', temoignage: 'Teinte parfaite à chaque fois' },
  //     { icon: 'Business', titre: 'Gestion dossiers assurances', description: 'Suivi expertises, facturations assurances, photos dégâts.', temoignage: 'Remboursements 2x plus rapides' },
  //     { icon: 'Build', titre: 'Planning atelier carrosserie', description: 'Gestion cabines peinture, séchage, véhicules prêt.', temoignage: 'Cabine toujours occupée' }
  //   ],
  //   temoignages: [
  //     { nom: 'Christophe Tôle', entreprise: 'Carrosserie CT', ville: 'Lille', avatar: 'CT', metier: 'Carrossier peintre', note: 5, chiffre: '+67% CA', texte: 'Devis automatiques temps/peinture font gagner 1h/véhicule. Je traite 2x plus !', resultats: { avant: '4 véhicules/semaine', apres: '8 véhicules/semaine', gain: '+100%' } },
  //     { nom: 'Philippe Déboss', entreprise: 'Débosselage Pro', ville: 'Roubaix', avatar: 'PD', metier: 'Carrossier débosseleur', note: 5, chiffre: '0 erreur teinte', texte: 'Teintométrie intégrée élimine les erreurs couleur. Satisfaction 100% !', resultats: { avant: '2 erreurs/mois', apres: '0 erreur', gain: '-100%' } },
  //     { nom: 'Éric Pare-chocs', entreprise: 'Pare-chocs Expert', ville: 'Tourcoing', avatar: 'EP', metier: 'Carrossier expert', note: 5, chiffre: 'x2.4 remboursements', texte: 'Gestion dossiers assurances accélère les paiements. Trésorerie fluide !', resultats: { avant: '45 jours délai', apres: '19 jours délai', gain: '-58%' } }
  //   ],
  //   fonctionnalites: ['Devis carrosserie auto', 'Teintométrie', 'Codes couleur constructeurs', 'Dossiers assurances', 'Photos dégâts', 'Planning cabines', 'Temps main d\'œuvre', 'Facturation assurances', 'Véhicules prêt', 'Suivi expertises', 'Stock peinture', 'Fiches réparation'],
  //   stats: { utilisateurs: '1 500+', satisfaction: '97%', gainTemps: '+81%', conversions: '+143%' },
  carrossiers: {
    id: 'carrossiers',
    nom: 'Carrossiers',
    nomPluriel: 'carrossiers',
    icon: 'Build',
    couleurMetier: '#FF9800',
    hero: {
      titre: 'La solution LYS pour carrossiers',
      soustitre: 'Gérez devis, teintométrie et dossiers assurances avec l’IA',
      badges: ['🚗 +72% productivité', '🎨 Teintométrie auto', '🛠️ 1 500+ carrossiers']
    },
    benefices: [
      { icon: 'Assignment', titre: 'Devis carrosserie automatiques', description: 'Calculs précis, base prix pièces, gestion sinistres.', temoignage: 'Devis validés par les assureurs' },
      { icon: 'ColorLens', titre: 'Teintométrie IA', description: 'Reconnaissance couleur, mélange auto, historique teintes.', temoignage: 'Plus d’erreur de couleur' },
      { icon: 'Verified', titre: 'Gestion dossiers assurances', description: 'Suivi sinistres, factures, photos, conformité.', temoignage: 'Dossiers acceptés du premier coup' }
    ],
    temoignages: [
      { nom: 'Sophie Carrosserie', entreprise: 'Carrosserie Pro', ville: 'Paris', avatar: 'SC', metier: 'Carrossier', note: 5, chiffre: '+72% productivité', texte: 'LYS m’a permis de doubler la rapidité de mes devis et d’éviter les erreurs de couleur.', resultats: { avant: '10 devis/semaine', apres: '18 devis/semaine', gain: '+80%' } },
      { nom: 'Julien Atelier', entreprise: 'Atelier Sud', ville: 'Marseille', avatar: 'JA', metier: 'Carrossier', note: 5, chiffre: '0 erreur couleur', texte: 'La teintométrie IA a éliminé les erreurs de couleur, les clients sont ravis.', resultats: { avant: '2 erreurs/mois', apres: '0 erreur', gain: '-100%' } }
    ],
    fonctionnalites: ['Devis carrosserie', 'Teintométrie IA', 'Gestion dossiers assurances', 'Base prix pièces', 'Photos sinistres', 'Facturation', 'Statistiques atelier', 'Planning équipes'],
    stats: { utilisateurs: '1 500+', satisfaction: '97%', gainTemps: '+72%', conversions: '+120%' },
    b2bEnabled: true,
    b2b: {
      titre: "LYS B2B - La carrosserie connectee et rentable",
      soustitre: "La plateforme tout-en-un pour developper et gerer votre atelier carrosserie",
      roi: { timeToValue: "58h", clientsGain: "+71 clients fidelises", caSupplement: "+23% CA", tempsGagne: "6.5h/sem gagnees" },
      pricing: [
        { nom: "Carrossier Solo", prix: "45€", periode: "/mois", features: ["1 utilisateur", "Devis auto", "Teintrometrie", "Support email"], cta: "Demarrer" },
        { nom: "Atelier Pro", prix: "89€", periode: "/mois", features: ["5 utilisateurs", "Planning atelier", "Analytics avances", "Support prioritaire"], cta: "Choisir Pro", recommended: true },
        { nom: "Entreprise Carrosserie+", prix: "Sur devis", periode: "", features: ["Utilisateurs illimites", "Multi-sites", "Gestion dossiers assurances", "Formation equipe"], cta: "Nous contacter" }
      ],
      arguments: ["Devis carrosserie automatiques", "Teintrometrie integree", "Dossiers assurances simplifies", "Gestion pieces detachees", "Support metier dedie"]
    },
    seo: { title: 'LYS Carrossiers - Logiciel Devis & Gestion Atelier Carrosserie', description: 'Logiciel carrossiers : devis auto, teintométrie, dossiers assurances. 1 500+ carrossiers.', keywords: 'logiciel carrossier, devis carrosserie, teintométrie, gestion assurances' },
    b2bEnabled: true
  },

  };

// Helper pour récupérer un métier
export const getMetier = (metierId) => {
  // Normalisation du slug pour tolérer fautes, accents, tirets, etc.
  if (!metierId) return null;
  const normalize = (str) => str
    .toLowerCase()
    .replace(/[éèêë]/g, 'e')
    .replace(/[àâä]/g, 'a')
    .replace(/[îï]/g, 'i')
    .replace(/[ôö]/g, 'o')
    .replace(/[ûü]/g, 'u')
    .replace(/ç/g, 'c')
    .replace(/-/g, '')
    .replace(/ /g, '')
    .replace(/[^a-z0-9]/g, '');
  const idNorm = normalize(metierId);

  // Gestion des anciens slugs/alias pour compatibilité
  const aliasMap = {
    menage: 'agentsDeMenage',
    controletechnique: 'centresDeControleTechnique'
  };
  const aliasKey = aliasMap[idNorm];
  if (aliasKey && metiers[aliasKey]) {
    return metiers[aliasKey];
  }

  for (const key of Object.keys(metiers)) {
    const metier = metiers[key];
    if (normalize(key) === idNorm) return metier;
    if (metier?.id && normalize(metier.id) === idNorm) return metier;
    if (Array.isArray(metier?.aliases)) {
      if (metier.aliases.some((alias) => normalize(alias) === idNorm)) {
        return metier;
      }
    }
  }
  return null;
};

// Helper pour lister tous les métiers
export const getAllMetiers = () => {
  return Object.values(metiers);
};

// Helper pour obtenir le slug d'inscription correspondant à un ID métier
export const getInscriptionSlug = (metierId) => {
  const inscriptionMap = {
    'agentsDeMenage': 'menage',
    'agents-de-menage': 'menage',
    'centresDeControleTechnique': 'controle-technique',
    'centres-de-controle-technique': 'controle-technique',
    'estheticiennes': 'estheticiennes',
    'estheticiens': 'estheticiennes'
  };
  return inscriptionMap[metierId] || metierId;
};

// Helper pour récupérer les métiers par catégorie (optionnel, pour navigation)
export const getMetiersByCategorie = () => {
  return {
    batiment: ['electriciens', 'plombiers', 'menuisiers', 'macons', 'carreleurs', 'couvreurs', 'peintres'],
    automobile: ['garagistes'],
    services: ['jardiniers', 'ramoneurs'],
    beaute: ['coiffeurs', 'estheticiens'],
    autres: ['fleuristes']
  };
};

export default metiers;
